/**
 * The slide out transition is used to standardize motion of when a element is exposed below a parent.
 * Example are dropdowns, autocompletes and comboboxes.
 */
export default (el: HTMLElement) => {
  el.setAttribute(
    "x-transition:enter",
    "transform transition duration-200 ease-custom"
  );
  el.setAttribute(
    "x-transition:enter-start",
    "-translate-y-1/2 scale-y-0 opacity-0"
  );
  el.setAttribute(
    "x-transition:enter-end",
    "translate-y-0 scale-y-100 opacity-100"
  );
  el.setAttribute(
    "x-transition:leave",
    "transform transition duration-100 ease-custom"
  );
  el.setAttribute(
    "x-transition:leave-start",
    "translate-y-0 scale-y-100 opacity-100"
  );
  el.setAttribute(
    "x-transition:leave-end",
    "-translate-y-1/2 scale-y-0 opacity-0"
  );
};
